import React from "react";
import team from "../data/teamData";
import TeamCard from "./TeamCard";

const AboutSection = () => {
  return (
    <section id="about" className="section">
      <h2 className="section__title">Meet Our Team</h2>
      <div className="about__grid">
        {team.map((member, index) => (
          <TeamCard
            key={index}
            name={member.name}
            role={member.role}
            image={member.image}
          />
        ))}
      </div>
    </section>
  );
};

export default AboutSection;
